import styled from "@emotion/styled";
import { Theme, Typography } from "@yuno/design-system-web";
import { useTranslation } from 'react-i18next'

const Tabs = styled.div<{ theme?: Theme }>`
  display: flex;
  align-items: center;
  justify-content: space-around;
  background-color: ${({ theme }) => theme.palette.grey[1]};
  padding: 4px;
  border-radius: 4px;
  margin-bottom: 24px;
`;

const Tab = styled.div<{ theme?: Theme; active: boolean }>`
  cursor: pointer;
  transition: all 0.1s ease-in-out;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 32px;
  ${({ active }) =>
    active
      ? {
          background: "white",
          borderRadius: "4px",
          boxShadow: "0px 1px 2px rgba(0, 0, 0, 0.05)",
        }
      : null};
  p {
    ${({ theme }) => theme.typography.small.regular};
    color: ${({ theme, active }) => !active && theme.palette.grey[4]};
    text-align: center;
  }
`;

export const TabSelector = ({ onChange, index }) => {
  const { t } = useTranslation()
  return (
    <Tabs>
      <Tab active={!index} onClick={onChange.bind(null, 0)}>
        <Typography>{t('styles.elements')}</Typography>
      </Tab>
      <Tab active={index} onClick={onChange.bind(null, 1)}>
        <Typography>{t('styles.container')}</Typography>
      </Tab>
    </Tabs>
  );
};
